import { useEffect, useState } from "react";
import TabsComponent from "../../components/main/Tabs";
import ReportConsulente from "./ReportConsulente";
import ReportFatturato from "./ReportFatturato";
import ReportMontatore from "./ReportMontatore";
import ReportOperator from "./ReportOperator";
import ReportOpVendite from "./ReportOpVendite";
import ReportOspiti from "./ReportOspiti";
import ReportLead from "./ReportLead";
import ReportPresaVisione from "./ReportPresavisione";
import { ReportsViewRoleAdmin, SuperAndAdvance } from "../../utils/genericList/ListRoleRoutes";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";
import { Categories, filterTabsByRole } from "../../utils/functions/filterTabsRole";
import ReportCalls from "./ReportCalls";
import { setCurrentTab } from "../../store/feautures/TabSlice";
import ReportEsito from "./ReportEsito";
import ReportFatturatoOpe from "./ReportFatturatoOperatori";

export default function ReportPage() {

    const { role } = useSelector(selectCurrentUserInfo);

    let [categories] = useState<Categories>({
        ReportOperatore: [
            {
                id: 1,
                component: <ReportOperator />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore']
            },
        ],
        StatisticheConsulente: [
            {
                id: 2,
                component: <ReportConsulente />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore']
            },
        ],
        StatisticheMontatore: [
            {
                id: 3,
                component: <ReportMontatore />,
                roles: ReportsViewRoleAdmin
            },
        ],
        VenditeOperatore: [
            {
                id: 4,
                component: <ReportOpVendite />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore']
            },
        ],
        ReportFatturato: [
            {
                id: 5,
                component: <ReportFatturato />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore']
            }
        ],
        ReportOspiti: [
            {
                id: 6,
                component: <ReportOspiti />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore', 'Consulente']
            }
        ],
        Lead: [
            {
                id: 7,
                component: <ReportLead />,
                roles: ReportsViewRoleAdmin
            }
        ],
        PresaVisione: [
            {
                id: 8,
                component: <ReportPresaVisione />,
                roles: SuperAndAdvance
            }
        ],
        ReportChiamate: [
            {
                id: 9,
                component: <ReportCalls />,
                roles: [...ReportsViewRoleAdmin]
            },
        ],
        ReportEsito: [
            {
                id: 10,
                component: <ReportEsito />,
                roles: [...ReportsViewRoleAdmin]
            },
        ],
        StatisticheFatturatoOperatore: [
            {
                id: 11,
                component: <ReportFatturatoOpe />,
                roles: [...ReportsViewRoleAdmin, 'Supervisore']
            },
        ],
    })
    
    const filteredCategories = filterTabsByRole(categories, role);
    const dispatch = useDispatch();
    
    useEffect(() => {
        return (() => {
            dispatch(setCurrentTab({ selectedTab: 0 }));
        });
    }, [])

    return (

        <>
            <h2 className="text-xl my-2">Reports</h2>
            <TabsComponent categories={filteredCategories} oriented='vertical' />
        </>
    )
}